import CryptoJS from "crypto-js";

const CLIENT_SALT = "a9f1036c2d65e6be39c3c6dfba749ae3";

// Gera chave dinâmica com offset opcional
function getDynamicKey(offset = 0) {
  const minute = Math.floor(Date.now() / 60000) + offset;
  const hash = CryptoJS.SHA256(CLIENT_SALT + minute);
  return CryptoJS.enc.Hex.parse(hash.toString());
}

function tryDecrypt(iv, ct, key) {
  try {
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ct },
      key,
      { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    const text = decrypted.toString(CryptoJS.enc.Utf8);
    return text || null;
  } catch (_) {
    return null;
  }
}

export function decryptDynamicResponse(encBase64) {
  const jsonStr = atob(encBase64);
  const payload = JSON.parse(jsonStr);

  const iv = CryptoJS.enc.Hex.parse(payload.iv);
  const ct = CryptoJS.enc.Hex.parse(payload.ct);

  const OFFSETS = [0, -1, +1, -2, +2];

  for (const off of OFFSETS) {
    const key = getDynamicKey(off);
    const result = tryDecrypt(iv, ct, key);
    if (result) return JSON.parse(result);
  }

  throw new Error("Dynamic AES decrypt failed.");
}
